export default __webpack_public_path__ + "22ab493aeef6a6ec9d93e07f02ee6a6b.png";